// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__269k5","modalForm":"UpgradeEpcsModal_modalForm__1gZLE","modalFooter":"UpgradeEpcsModal_modalFooter__36NDK"};